export default __webpack_public_path__ + "static/media/fetch_pals_post2.663a0cdc.jpg";